import * as React from 'react'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { iosLink: defaultLink },
} = getConfig()

const AppStore = ({ width = 135, height = 40, link = defaultLink }) => {
  return (
    <a
      href={link}
      style={{
        display: 'inline-block',
        overflow: 'hidden',
        background:
          'url(https://linkmaker.itunes.apple.com/ja-jp/badge-lrg.svg?releaseDate=2019-02-13&kind=iossoftware&bubble=ios_apps) no-repeat',
        width,
        height,
        margin: 10,
      }}
    />
  )
}

export default AppStore
